import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterLoanAgrPpaPageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='loan_agreement_ppa'
        title='PPA terms'
        activeTab='loanAgreement'
        navConfig={{ loanAgrPage: 'loanSpecific', subNavType: 'loanSpecific', subNavPage: 'ppa' }}
      />
    )
  }
}

export default MasterLoanAgrPpaPageSF
